import { Dictionary } from "@/core/i18n";

const ISSUE_KEY_TO_TRANSLATION: Record<string, string> = {
  inappropriate_content: "assessmentSteps.studioSession.preview.serverIssue.inappropriate_content",
  underage_person: "assessmentSteps.studioSession.preview.serverIssue.underage_person",
  validation_unavailable:
    "assessmentSteps.studioSession.preview.serverIssue.validation_unavailable",
  too_bright: "assessmentSteps.studioSession.preview.serverIssue.too_bright",
  too_dark: "assessmentSteps.studioSession.preview.serverIssue.too_dark",
  blurry: "assessmentSteps.studioSession.preview.serverIssue.blurry",
  multiple_faces: "assessmentSteps.studioSession.preview.serverIssue.multiple_faces",
  no_clear_face_visible: "assessmentSteps.studioSession.preview.serverIssue.no_clear_face_visible",
  face_obstructed: "assessmentSteps.studioSession.preview.serverIssue.no_clear_face_visible",
  sunglasses: "assessmentSteps.studioSession.preview.serverIssue.sunglasses",
  hat: "assessmentSteps.studioSession.preview.serverIssue.hat",
  hoodie: "assessmentSteps.studioSession.preview.serverIssue.hoodie",
  cap: "assessmentSteps.studioSession.preview.serverIssue.cap",
  beanie: "assessmentSteps.studioSession.preview.serverIssue.beanie",
  headscarf: "assessmentSteps.studioSession.preview.serverIssue.headscarf",
  head_covering: "assessmentSteps.studioSession.preview.serverIssue.head_covering",
  glasses: "assessmentSteps.studioSession.preview.serverIssue.glasses",
};

export function getValidationIssueTranslationKey(issueKey: string): string {
  return (
    ISSUE_KEY_TO_TRANSLATION[issueKey] ??
    "assessmentSteps.studioSession.preview.serverRejectedFallback"
  );
}

export function getValidationIssueTranslationKeyWithFallback(
  issueKey: string,
  fallbackTranslationKey: string,
): keyof Dictionary {
  return (ISSUE_KEY_TO_TRANSLATION[issueKey] ?? fallbackTranslationKey) as keyof Dictionary;
}
